// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UnauthorizedErrorSchema = z.object({
  error: z.coerce.string().min(1).describe("Error message"),
});
